import { TwtBrand } from "~/components/TwtBrand";
import { publicSerif } from "~/styles/fonts/publicSerif";
import { clerkAwareLogoutClick } from "~/utils/clerkBrowserSignOut";

function discordUpdatesUrl() {
  return (
    process.env.NEXT_PUBLIC_DISCORD_VANITY_URL ||
    "https://discord.gg/tradewithtitans"
  );
}

export function DashboardUnavailable({
  retryAfterMs,
  reason,
}: {
  retryAfterMs?: number;
  reason?: "authentication" | "agreements";
}) {
  const actionClass =
    "inline-flex min-h-10 items-center justify-center rounded-md border border-[#d8d5c4] bg-white px-4 text-body font-medium text-[#3a3a36] transition hover:border-[#8a8980] hover:bg-[#faf9f5] hover:text-[#141413]";
  return (
    <main className={`${publicSerif.variable} min-h-screen bg-[#fbfaf7] text-[#141413]`}>
      <section className="mx-auto flex min-h-screen max-w-[720px] flex-col items-center justify-center px-6 py-16 text-center">
        <TwtBrand size="lg" />
        <div className="mt-10 rounded-[8px] border border-[#e7e3d8] bg-white px-8 py-8 shadow-[0_1px_2px_rgba(20,20,19,0.03)]">
          <p className="text-caption text-[#6a6a62]">
            503: Service temporarily unavailable
          </p>
          <h1 className="mt-3 text-display font-semibold [font-family:var(--twt-public-serif),Georgia,serif]">
            {reason === "agreements"
              ? "Agreement check temporarily unavailable."
              : "Dashboard temporarily unavailable."}
          </h1>
          <p className="mt-3 text-paragraph text-[#5d5b54]">
            {reason === "authentication"
              ? "We cannot check your sign-in right now. Your account is unaffected. Please try again."
              : reason === "agreements"
              ? "We cannot check your agreement right now. Your account is unaffected. Please try again."
              : "We cannot load current account access right now. Your account is unaffected. Please try again."}
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <a className={actionClass} href={discordUpdatesUrl()}>
              Check Discord updates
            </a>
            <button
              className={actionClass}
              type="button"
              onClick={() => location.reload()}
            >
              Retry now
            </button>
            {reason === "authentication" ? (
              <a
                className={actionClass}
                href="/api/logout"
                onClick={clerkAwareLogoutClick}
              >
                Sign out
              </a>
            ) : null}
          </div>
          {retryAfterMs ? (
            <p className="mt-4 text-caption text-[#6a6a62]">
              Try again in about {Math.ceil(retryAfterMs / 1000)} seconds.
            </p>
          ) : null}
        </div>
      </section>
    </main>
  );
}
